import { render } from "./CGrid.vue?vue&type=template&id=23fba056&scoped=true&ts=true"
import script from "./CGrid.vue?vue&type=script&lang=ts"
export * from "./CGrid.vue?vue&type=script&lang=ts"

import "./CGrid.vue?vue&type=style&index=0&id=23fba056&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23fba056"]])

export default __exports__